import { PartnerGroup } from "app/model/shared/transaction/partner";
import { BaseResponse } from "./internal/baseresponse";

export class PartnerGroupResult extends BaseResponse {
    data: Array<PartnerGroup>;
  }
  


// WEBPACK FOOTER //
// ./src/app/response/partnergroupresult.ts